import React from 'react';

import { Heading } from '../Heading/Heading';

export interface AdmonitionTitleProps {
  children: React.ReactNode;
}

export const AdmonitionTitle = ({ children }: AdmonitionTitleProps) => {
  return <Heading variant="title">{children}</Heading>;
};
